import {
  Conversation,
  ConversationLogItemParticipantJoined,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui/deprecated';
import {JoinRow} from '../../Chat/Row/JoinRow';

export const ParticipantJoinedRow = ({
  conversation,
  item,
}: {
  conversation: Conversation;
  item: ConversationLogItemParticipantJoined;
}) => {
  if (item.participant.id === conversation.user.id) {
    return null;
  }

  return (
    <view.div
      className="uh-conversations-contains-meta-row"
      data-testid="conversation-log-participant-joined"
    >
      <JoinRow
        name={item.participant.displayName}
        role={item.participant.role}
      />
    </view.div>
  );
};
